import React from 'react'
import Section from '../Section'
import ExperienceUnit from '../ExperienceUnit'

import d30u30Logo from '../../assets/images/awards/d30_30_logo.jpg'
import androidExperimentsLogo from '../../assets/images/awards/android_experiments_logo_5.jpg'
import littleNomadLogo from '../../assets/images/projects/little-nomad.png'

class AwardsSection extends React.Component {
  render() {
    return (
      <Section title="Awards">
        <div className="row">
          <ExperienceUnit
            logo={d30u30Logo}
            colour="#000000"
            title="Developer 30 Under 30"
            link="https://www.canadianbusiness.com/innovation/developer-30-under-30-gallery/image/14/"
            timeperiod="2017"
            subtitle="Recognized as one of the top 30 software developers under the age of 30 in Canada."
          />
          <ExperienceUnit
            logo={androidExperimentsLogo}
            colour="#104B24"
            title="Android Experiments Winner"
            link="https://experiments.withgoogle.com/hungermoji"
            timeperiod="2016"
            subtitle={<span>My app HungerMoji was a winner of Google’s Android Experiments I/O Challenge. Featured in <a href="https://www.wired.co.uk/article/best-android-apps" target="_blank">Wired UK</a>, <a href="https://ca.news.yahoo.com/google-android-experiments-winners-android-100647011.html" target="_blank">Yahoo Tech</a>, <a href="https://www.makeuseof.com/tag/amazing-android-experiments-best-android/" target="_blank">MakeUseOf</a></span>}
          />
        </div>
      </Section>
    )
  }
}

export default AwardsSection



// WEBPACK FOOTER //
// ./src/components/AwardsSection/index.js